import { ReactElement } from "react";
import { Button } from "@twilio-paste/core/button";
import { NotesIcon } from "@twilio-paste/icons/esm/NotesIcon";
import { copy, types } from "./defintions";
import { useSurveyContext } from "../../hooks";

const AssistantFeedbackButton = ({
  handleClick,
}: types.HcaFeedbackButtonProps): ReactElement => {
  const {
    state: { displayName },
  } = useSurveyContext();
  return (
    <Button variant="secondary" size="small" onClick={handleClick}>
      <NotesIcon decorative />
      {displayName ? copy.buttonText(displayName) : copy.defaultButtonText}
    </Button>
  );
};

export default AssistantFeedbackButton;
